import { VStack } from '@chakra-ui/layout';

function HowToReferDemo() {
  return (
    <VStack mt={20} alignItems="center">
      <video width="800" height="100%" controls>
        <source src="/files/how_to_refer.mp4" type="video/mp4" />
      </video>
    </VStack>
  );
}

export default HowToReferDemo;
